import { createApiClient } from './client'

/**
 * Feed types — mirror backend/src/modules/feed/types/feed.types.ts
 */
export type FeedCardKind =
  | 'next_step'
  | 'gear_need'
  | 'meal_need'
  | 'weather_alert'
  | 'invite'
  | 'poll'
  | 'event'
  | 'ai_recommendation'
  | 'ai_upsell'
  | 'weekend_suggestion'
  | 'weekend_suggestion_setup'

export type FeedPriority = 'urgent' | 'high' | 'medium' | 'low'

export interface FeedCard {
  id: string
  kind: FeedCardKind
  priority: FeedPriority
  title: string
  body: string
  icon: string
  tripId?: string
  tripName?: string
  actionUrl?: string
  actionText?: string
  sortAt: string
  isPro: boolean
  metadata?: Record<string, unknown>
}

export interface FeedResponse {
  cards: FeedCard[]
  tier: 'free' | 'pro'
  aiEnabled: boolean
  generatedAt: string
}

/**
 * Feed API client.
 */
export class FeedApi {
  private apiClient: ReturnType<typeof createApiClient>

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
  }

  /** GET /api/v1/feed */
  async getFeed(limit?: number): Promise<FeedResponse> {
    const response = await this.apiClient.get<{ success: boolean; data: FeedResponse }>(
      '/feed',
      limit ? { limit } : undefined
    )
    return response.data
  }
}
